module.exports = __webpack_public_path__ + "img/Red.3bccb336.png";